import { TextInput } from '@carbon/react';
import { useCategoryFields } from '../template-hooks';
import type { NumericRangeFilterField, FilterTemplateProps } from '../../types';
import style from '../filter-modal.module.scss';

interface NumericRangeRowProps {
  field: NumericRangeFilterField;
  formValues: Record<string, unknown>;
  onFormChange: (key: string, value: unknown) => void;
}

const NumericRangeRow = ({
  field,
  formValues,
  onFormChange,
}: NumericRangeRowProps) => (
  <div className={style.rangeRow}>
    <h6 className={style.rangeLabel}>{field.label}</h6>
    <div className={style.rangeInputs}>
      <TextInput
        id={`filter-${field.minParam}`}
        labelText="Min"
        type="number"
        value={(formValues[field.minParam] as string) ?? ''}
        onChange={(e) =>
          onFormChange(field.minParam, e.target.value || undefined)
        }
        size="md"
      />
      <TextInput
        id={`filter-${field.maxParam}`}
        labelText="Max"
        type="number"
        value={(formValues[field.maxParam] as string) ?? ''}
        onChange={(e) =>
          onFormChange(field.maxParam, e.target.value || undefined)
        }
        size="md"
      />
    </div>
  </div>
);

export const NumericRangeTemplate = ({
  category,
  formValues,
  onFormChange,
}: FilterTemplateProps) => {
  const fields = useCategoryFields(category, 'numeric-range');

  return (
    <div>
      {fields.map((field) => (
        <NumericRangeRow
          key={field.id}
          field={field}
          formValues={formValues}
          onFormChange={onFormChange}
        />
      ))}
    </div>
  );
};
